import { useEffect, useState } from 'react';
import useVideoContext from './useVideoContext';
import useParticipants from './useParticipants';

export default () => {
  const { room, localTracks } = useVideoContext();
  const participants = useParticipants();
  const [screenShareParticipant, setScreenShareParticipant] = useState();
  const [participantsVideoStatuses, setParticipantsVideoStatuses] = useState([]);
  const [participantsAudioStatuses, setParticipantsAudioStatuses] = useState([]);

  useEffect(() => {
    if (room) {
      const updateScreenShareParticipant = () => {
        setScreenShareParticipant(
          Array.from(room.participants.values())
            .concat(room.localParticipant)
            .find((participant) => Array.from(participant.tracks.values()).find((track) => track.name?.includes('screen') && track.kind === 'video')),
        );

        setParticipantsVideoStatuses(
          Array.from(room.participants.values())
            .concat(room.localParticipant)
            .filter((participant) => Array.from(participant.tracks.values()).find((track) => track.trackName !== 'screen' && track.kind === 'video' && track.isTrackEnabled)),
        );

        setParticipantsAudioStatuses(
          Array.from(room.participants.values())
            .concat(room.localParticipant)
            .filter((participant) => Array.from(participant.tracks.values()).find((track) => track.kind === 'audio' && track.isTrackEnabled)),
        );
      };
      updateScreenShareParticipant();

      room.on('trackPublished', updateScreenShareParticipant);
      room.on('trackUnpublished', updateScreenShareParticipant);
      room.on('participantDisconnected', updateScreenShareParticipant);
      room.on('trackStopped', updateScreenShareParticipant);
      room.on('trackEnabled', updateScreenShareParticipant);
      room.on('trackDisabled', updateScreenShareParticipant);

      room.localParticipant.on('trackPublished', updateScreenShareParticipant);
      room.localParticipant.on('trackUnpublished', updateScreenShareParticipant);
      room.localParticipant.on('trackSubscribed', updateScreenShareParticipant);
      room.localParticipant.on('trackStopped', updateScreenShareParticipant);
      room.localParticipant.on('trackRemoved', updateScreenShareParticipant);
      room.localParticipant.on('trackEnabled', updateScreenShareParticipant);
      room.localParticipant.on('trackDisabled', updateScreenShareParticipant);
      return () => {
        room.off('trackPublished', updateScreenShareParticipant);
        room.off('trackUnpublished', updateScreenShareParticipant);
        room.off('participantDisconnected', updateScreenShareParticipant);
        room.off('trackStopped', updateScreenShareParticipant);
        room.off('trackEnabled', updateScreenShareParticipant);
        room.off('trackDisabled', updateScreenShareParticipant);

        room.localParticipant.off('trackPublished', updateScreenShareParticipant);
        room.localParticipant.off('trackUnpublished', updateScreenShareParticipant);
        room.localParticipant.off('trackSubscribed', updateScreenShareParticipant);
        room.localParticipant.off('trackStopped', updateScreenShareParticipant);
        room.localParticipant.off('trackRemoved', updateScreenShareParticipant);
        room.localParticipant.off('trackEnabled', updateScreenShareParticipant);
        room.localParticipant.off('trackDisabled', updateScreenShareParticipant);
      };
    }
  }, [room, localTracks]);

  return {
    participantsVideoStatuses: participantsVideoStatuses.map((participant) => participant.identity),
    participantsAudioStatuses: participantsAudioStatuses.map((participant) => participant.identity),
    participantsScreenStatuses: [screenShareParticipant?.identity],
    participantsJoinStatuses: participants.map((participant) => participant.identity),
  };
};
